import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Login from "./pages/auth/Login";
import SignUp from "./pages/auth/SignUp";
import Home from "./pages/home/Home";
import Renew from "./pages/renewal/Renew";
import RenewInfo from "./pages/renewal/RenewInfo";
import RenewWrapper from "./pages/renewal/RenewWrapper";
import History from "./pages/history/History";
import CreditHistory from "./pages/history/CreditHistory";
import DebitHistory from "./pages/history/DebitHistory";
import AllHistory from "./pages/history/AllHistory";
import Customers from "./pages/customers/Customers";
import { useState } from "react";
import PublicRoute from "./middleware/PublicRoute";
import PrivateRoute from "./middleware/PrivateRoute";
import { useSelector } from "react-redux";
import DistributorHome from "./pages/home/DistributorHome";
import DistributorCustomers from "./pages/customers/DistributorCustomers";
import DistributorCredit from "./pages/history/DistributorCredit";
import DistributorDebit from "./pages/history/DistributorDebit";
import RenewCart from "./pages/renewal/RenewCart";
import OrderDetails from "./pages/history/OrderDetails";
import CustomerInfo from "./pages/customers/CustomerInfo";
import TermsAndCondition from "./pages/terms/TermsAndCondition";
import PrivacyPolicy from "./pages/terms/PrivacyPolicy";
import SoldPins from "./pages/history/SoldPins";
import BoughtPins from "./pages/history/BoughtPins";
import DistributorPinList from "./pages/pins/DistributorPinList";
import FixedAgentPins from "./pages/pins/FixedAgentPins";
import ExportedPins from "./pages/history/ExportedPins";
import RequestReset from "./pages/auth/RequestReset";
import ResetPassword from "./pages/auth/ResetPassword";
import EditRenewal from "./pages/renewal/EditRenewal";
import UpdateConfirmation from "./pages/cei/UpdateConfirmation";
import InsuranceSync from "./pages/insurance-sync/InsuranceSync";
// import { userDataActions } from "./store/redux-store/Index";

function App() {
  const [showMenu, setShowMenu] = useState(false);

  const accountType = useSelector(
    (state) => state.userData.loginData.account_type,
  );

  const router = createBrowserRouter([
    {
      path: "/login",
      element: (
        <PublicRoute>
          <Login />
        </PublicRoute>
      ),
    },
    {
      path: "/register",
      element: <SignUp />,
    },
    {
      path: "/request-password-reset",
      element: <RequestReset />,
    },
    {
      path: "/password-reset",
      element: <ResetPassword />,
    },
    {
      path: "/",
      element: (
        <PrivateRoute>
          {accountType === "DISTRIBUTOR" ? (
            <DistributorHome showMenu={showMenu} setShowMenu={setShowMenu} />
          ) : (
            <Home showMenu={showMenu} setShowMenu={setShowMenu} />
          )}
        </PrivateRoute>
      ),
    },

    {
      path: "/history/:id",
      element: (
        <PrivateRoute>
          <OrderDetails showMenu={showMenu} setShowMenu={setShowMenu} />
        </PrivateRoute>
      ),
    },

    {
      path: "/customers",
      element: (
        <PrivateRoute>
          {accountType === "DISTRIBUTOR" ? (
            <DistributorCustomers
              showMenu={showMenu}
              setShowMenu={setShowMenu}
            />
          ) : (
            <Customers showMenu={showMenu} setShowMenu={setShowMenu} />
          )}
        </PrivateRoute>
      ),
    },

    {
      path: "/pins",
      element: (
        <PrivateRoute>
          {accountType === "DISTRIBUTOR" && (
            <DistributorPinList showMenu={showMenu} setShowMenu={setShowMenu} />
          )}
        </PrivateRoute>
      ),
    },
    {
      path: "/fixed-agent/pins",
      element: (
        <PrivateRoute>
          {accountType !== "DISTRIBUTOR" && (
            <FixedAgentPins showMenu={showMenu} setShowMenu={setShowMenu} />
          )}
        </PrivateRoute>
      ),
    },

    {
      path: "/add-customer",
      element: (
        <PrivateRoute>
          <CustomerInfo showMenu={showMenu} setShowMenu={setShowMenu} />
        </PrivateRoute>
      ),
    },
    {
      path: "/terms",
      element: (
        <PrivateRoute>
          <TermsAndCondition showMenu={showMenu} setShowMenu={setShowMenu} />
        </PrivateRoute>
      ),
    },
    {
      path: "/privacy",
      element: (
        <PrivateRoute>
          <PrivacyPolicy showMenu={showMenu} setShowMenu={setShowMenu} />
        </PrivateRoute>
      ),
    },
    {
      path: "/history",
      element: (
        <PrivateRoute>
          <History showMenu={showMenu} setShowMenu={setShowMenu} />
        </PrivateRoute>
      ),
      children: [
        {
          path: "/history",
          element: <AllHistory showMenu={showMenu} setShowMenu={setShowMenu} />,
        },

        {
          path: "credit",
          element:
            accountType === "DISTRIBUTOR" ? (
              <DistributorCredit
                showMenu={showMenu}
                setShowMenu={setShowMenu}
              />
            ) : (
              <CreditHistory showMenu={showMenu} setShowMenu={setShowMenu} />
            ),
        },
        {
          path: "debit",
          element:
            accountType === "DISTRIBUTOR" ? (
              <DistributorDebit showMenu={showMenu} setShowMenu={setShowMenu} />
            ) : (
              <DebitHistory showMenu={showMenu} setShowMenu={setShowMenu} />
            ),
        },
      ],
    },

    {
      path: "/pin-history",
      element: (
        <PrivateRoute>
          <History showMenu={showMenu} setShowMenu={setShowMenu} />
        </PrivateRoute>
      ),
      children: [
        {
          path: "/pin-history",
          element: <AllHistory showMenu={showMenu} setShowMenu={setShowMenu} />,
        },
        {
          path: "sold-pins",
          element: <SoldPins showMenu={showMenu} setShowMenu={setShowMenu} />,
        },
        {
          path: "exported-pins",
          element: (
            <ExportedPins showMenu={showMenu} setShowMenu={setShowMenu} />
          ),
        },
        {
          path: "bought-pins",
          element: <BoughtPins showMenu={showMenu} setShowMenu={setShowMenu} />,
        },
      ],
    },
    {
      path: "/renew",
      element: (
        <PrivateRoute>
          <RenewWrapper showMenu={showMenu} setShowMenu={setShowMenu} />
        </PrivateRoute>
      ),
      children: [
        {
          path: "/renew",
          element: <Renew showMenu={showMenu} setShowMenu={setShowMenu} />,
        },
        {
          path: "info",
          element: <RenewInfo showMenu={showMenu} setShowMenu={setShowMenu} />,
        },
        {
          path: "cart",
          element: <RenewCart showMenu={showMenu} setShowMenu={setShowMenu} />,
        },
      ],
    },

    {
      path: "/insurance-sync",
      element: (
        <PrivateRoute>
          {accountType === "DISTRIBUTOR" && (
            <InsuranceSync showMenu={showMenu} setShowMenu={setShowMenu} />
          )}
        </PrivateRoute>
      ),
    },

    {
      path: "/cei/update",
      element: <UpdateConfirmation />,
    },

    {
      path: "/edit-order/:id",
      element: (
        <PrivateRoute>
          <EditRenewal showMenu={showMenu} setShowMenu={setShowMenu} />
        </PrivateRoute>
      ),
    },
  ]);

  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
